<template>
  <md-content class="kab-detail-content md-layout">
    <div class="md-layout-item md-size-30 apprentice-user-details">
      <div class="md-layout md-alignment-center-center">
        <img
          alt="kab logo"
          class="image-avatar"
          :src="userImage"
        >
      </div>
      <div class="md-layout md-alignment-center-center">
        <p
          class="user-name"
          v-html="title"
        />
      </div>
      <div class="md-layout md-alignment-center-center">
        <p
          class="studio-name"
          v-html="studioName"
        />
      </div>
    </div>
    <div class="md-layout-item">
      <p v-html="body" />
    </div>
  </md-content>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: "ApprenticesDetails",
  props: {
    title: {
      type: String,
      required: true
    },
    studioName: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  computed: {
    userImage () {
      return this.image.length ? this.image : require('@/assets/avatar.svg')
    }
  }
}
</script>
<style lang="scss" scoped>
.kab-detail-content {
  margin: 36px;
}
.apprentice-user-details {
  width: 250px;
  margin-right: 40px;
  img {
    width: 184px;
    height:184px;
    display: block;
    margin: auto;
    border-radius: 50%;
    border: 2px solid $color-primary;
  }
  p {
    &.user-name {  
      font-size: 14px;
      font-weight: bold; 
      line-height: 1.5; 
      color: #000000;
      margin-bottom: 0px;
    }
    &.studio-name {
      font-size: 12px;
      font-style: italic;
      line-height: 1.75;
      text-align: center;
      color: #a1aeb7;
    }
  }
}

</style>